







































































































































































import { Component, Vue, Watch } from "vue-property-decorator";;
import { PubBiddingService } from "@/zh-website/src/views/partner/service/pubBidding";
import SwiperNews from "@/zh-website/src/components/website/Swiper/SwiperNews.vue";
import SwiperPubBidding from "@/zh-website/src/components/website/Swiper/SwiperPubBidding.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
@Component({
  components: { SwiperNews, Swiper, SwiperSlide, SwiperPubBidding }
})
export default class Supplier extends Vue {
  @Watch("$route", { immediate: true })
  onCatalogIdChange() {
    this.active = parseInt(this.$route.params.type) + 1;
    this.handleSelectTab(this.$route.params.type);
  }
  newjump = "/home/pub/bidding/";
  rightNew: any = [];
  leftNew: any = {};
  arrDom;
  tabList = [
    { id: 1, name: "合作模式" },
    { id: 2, name: "专家权益" },
    { id: 3, name: "常见问题" },
    { id: 4, name: "申请加入" },
    { id: 5, name: "合作流程" }
  ];
  TabFix = false;
  active = 0;
  offsetTop = 868;
  SwiperShare2 = {
    slidesPerView: 3,
    spaceBetween: 35,
    loop: true,
    autoplay: false,
    breakpoints: {
      //当宽度大于等于320
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于480
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于640
      640: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 35
      },
      1366: {
        slidesPerView: 3,
        spaceBetween: 35
      }
    }
  };
  ChannelList = [
    {
      tag1: 0,
      updateDate: 1586483118000,
      plural: 0,
      reading: 0,
      collection: 0,
      sort: 1,
      tag2: 0,
      isShow: 1,
      tag3: 0,
      field1: "关于采购",
      dictCode: "036",
      content1:
        '<p><br/></p><p style="text-align: center;"><span style="text-align: center;"></span><span style="text-align: center; color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; background-color: rgb(255, 255, 255);">渠道合作相关内容待开放，敬请期待</span></p>',
      id: "h59c13wjj4gRq98A066G02338I11585636693501",
      field2: require("../../assets/partner_supplier_channel3.png"),
      group: "036",
      createDate: 1585636693000,
      link: "/partner/about-purchase"
    },
    {
      tag1: 0,
      updateDate: 1632907658000,
      plural: 0,
      reading: 0,
      collection: 0,
      sort: 1,
      tag2: 0,
      isShow: 1,
      tag3: 0,
      field1: "免责声明",
      dictCode: "036",
      content2: "",
      content1:
        '<p><span style="text-align: center;"></span><br/></p><p style="text-align: center;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; text-align: center;"></span><span style="text-align: center; color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; background-color: rgb(255, 255, 255);"></span></span></p><p style="text-align:center"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 21px;">关于规范渠道授权的通知</span></strong><strong><span style="font-size: 21px;"></span></strong><strong><span style="font-size: 21px;"></span></strong></span></p><p style="line-height:150%"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 16px; line-height: 150%;">致<span style="text-decoration: underline;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>：</span></strong><strong><span style="font-size: 16px; line-height: 150%;"></span></strong><strong><span style="font-size: 16px; line-height: 150%;"></span></strong></span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">为维护市场秩序，保障双方的共同利益，我司将加强对渠道项目的商务授权管理，请按相关流程开展合作：<span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; color: red;"> </span></span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">对于需开具商务《授权函》的项目，请渠道伙伴联系我方业务人员，相应项目经评审通过后，我方会以正式授权文件形式给予必要的商务支持。</span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">对于未获得我司授权却以我司名义参与投标，若发生交付等各风险，我司有追责的权利；同时我司会按情节严重情况，考虑是否取消合作。</span></p><p style="text-align:left;text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">以上通知若合作中遇到问题，反馈。</span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">特此通知。</span></p><p style="text-align: center;"><span style="text-align: center; color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; background-color: rgb(255, 255, 255);"></span><br/></p><p><br/></p><p style="text-indent: 32px; line-height: 150%; text-align: right;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 16px; line-height: 150%;">浙江华为通信技术有限公司</span></strong></span></p><p style="text-align: right;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 16px; line-height: 150%; font-family: 宋体;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></strong></span>日期：2021年9月30日</p><p style="text-align: right;"><br/></p>',
      id: "N26Dg6C459EpayNCV66PjPsY81a1585636685540",
      field2: require("../../assets/partner_supplier_channel1.png"),
      group: "036",
      createDate: 1585636685000,
      link: "/partner/liability-exemption"
    },
    {
      tag1: 0,
      updateDate: 1586483045000,
      plural: 0,
      reading: 0,
      collection: 0,
      sort: 1,
      tag2: 0,
      isShow: 1,
      tag3: 0,
      field1: "反腐败政策",
      dictCode: "036",
      content1:
        '<p style="text-align: center;"><br/></p><p style="text-align: center;"><span style="color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; text-align: center; background-color: rgb(255, 255, 255);">渠道合作相关内容待开放，敬请期待</span></p>',
      id: "yZ2508je79lmSU0Ulm9Ajz40F5P1581311981676",
      field2: require("../../assets/partner_supplier_channel2.png"),
      group: "036",
      createDate: 1581311981000,
      link: "/partner/anti-corruption"
    }
  ];
  created() {
    // this.sex = 0;
  }
  mounted() {
    //记录每个内容对用的dom数组
    this.arrDom = document.getElementsByClassName("TabContent");
    window.addEventListener("scroll", this.handleScroll);
    this.active = parseInt(this.$route.params.type) + 1;
    this.handleSelectTab(this.$route.params.type);
    this._getRightNew();
  }
  async _getRightNew() {
    console.log('get pub bidding');
    PubBiddingService.getPubBiddingList({ pageNum: 1, pageSize: 5, timeFrameCode: 1 }).then(
      (res: any) => {
        if (res.data.list.length > 0) {
          this.leftNew = res.data.list[0];
          this.rightNew = res.data.list.slice(1, res.data.list.length);
        } else {
          this.leftNew = {};
          this.rightNew = [];
        }
      }
    );
  }
  on_top_enter() {
    //
  }
  on_top_leave() {
    //
  }
  handleScroll(e) {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.TabFix = scrollTop > this.offsetTop;
    for (let i = 0; i < this.arrDom.length; i++) {
      //因为下面使用到了i+1，所以需要把最后一个分离出来判断
      if (this.arrDom[this.arrDom.length - 1].offsetTop - scrollTop > 80) {
        if (
          this.arrDom[i].offsetTop - scrollTop <= 80 &&
          this.arrDom[i + 1].offsetTop - scrollTop > 80
        ) {
          this.active = i + 1;
        } else {
          //
        }
      } else {
        this.active = this.arrDom.length;
      }
    }
  }

  handleSelectTab(id) {
    for (let i = 0; i < this.tabList.length; i++) {
      if (i + 1 == id) {
        this.arrDom[i].scrollIntoView({
          behavior: "smooth",
          block: "start" // 上边框与视窗顶部平齐。默认值
        });
        document.documentElement.scrollTop = this.arrDom[i].offsetTop - 80;
      }
    }
    this.active = id;
  }
}
